import { fetcher } from "helpers/fetcher";

import {
  TSubmitEODReportDetailsReq,
  TSubmitEODReportDetailsRes,
} from "./types";
import { API_HEADER } from "../constants";
import { ENDPOINT } from "../endpoint";

export const submitEODReportDetails = async (
  payload: TSubmitEODReportDetailsReq
) => {
  return await fetcher<
    TSubmitEODReportDetailsRes,
    TSubmitEODReportDetailsReq["data"]
  >(ENDPOINT.MANAGEMENT.SUBMIT_EOD_REPORT_DETAILS, {
    data: payload.data,
    headers: {
      [API_HEADER.VERSION]:
        ENDPOINT.MANAGEMENT.SUBMIT_EOD_REPORT_DETAILS.version,
      [API_HEADER.BU_ID]: payload.idBu,
    },
  });
};

export const mutationSubmitEODReportDetails = async (
  payload: TSubmitEODReportDetailsReq
) => {
  return (await submitEODReportDetails(payload)).data.message;
};

mutationSubmitEODReportDetails._key = (payload: TSubmitEODReportDetailsReq) => [
  ENDPOINT.MANAGEMENT.SUBMIT_EOD_REPORT_DETAILS.url,
  payload,
];
